const forbidden = (res) => res.status(403).json({ status: 'FORBIDDEN' });
const unauthorized = (res) => res.status(401).json({ status: 'UNAUTHORIZED' });
const invalid = (res) => res.status(400).json({ status: 'INVALID REQUEST' });
const notFound = (res) => res.status(404).json({ status: 'NOT FOUND' });
const error = (res) => res.status(500).json({ status: 'ERROR' });
const ok = (res) => res.status(200).json({ status: 'OK' });

const Api = {
    forbidden,
    unauthorized,
    invalid,
    notFound,
    error,
    ok,
};

export default Api;
